





















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import ICustomfield from "@/interfaces/ICustomfield";
import {BPopover} from "bootstrap-vue";


@Component({
	components: {BPopover},
})
export default class EditCustomfieldModal extends Vue {

	@Prop({
		required: true,
		type: Object
	})
	public customfield!: ICustomfield;

	public newName: string = '';
	public newHelp: string = '';
	public newPlaceholder: string = '';
	public newType: string = 'text';
	public newRequired: number = 0;
	public newInternal: number = 0;
	public newShowInList: number = 0;
	public newShowInDetails: number = 0;
	public newSelectValues: string[] = [''];

	public showError: boolean = false;
	public isLoading: boolean = false;

	public $refs!: {
		editCustomfieldModal: any
	};

	private $http!: AxiosStatic;

	get id() {
		return this.customfield.id;
	}

	public mounted() {
		this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
			if (modalId === 'editCustomfieldModal') {
				this.reset();
			}
		})
	}

	@Watch('customfield', { immediate: true })
	public reset() {
		if (this.customfield) {
			this.newName = this.customfield.name;
			this.newHelp = this.customfield.help;
			this.newPlaceholder = this.customfield.placeholder;
			this.newType = this.customfield.type;
			this.newRequired = this.customfield.required;
			this.newInternal = this.customfield.internal;
			this.newShowInList = this.customfield.show_in_list;
			this.newShowInDetails = this.customfield.show_in_details;
			this.newSelectValues = JSON.parse(this.customfield.select_values);
		}
	}

	public open() {
		this.$refs['editCustomfieldModal'].show()
	}

	public close() {
		this.$refs['editCustomfieldModal'].hide()
	}

	public addOption() {
		this.newSelectValues.push('');
	}

	public removeOption(index: number) {
		this.newSelectValues.splice(index, 1);
	}

	public save() {
		if (this.newName.length > 0) {
			this.isLoading = true;
			this.showError = false;
			let nonEmptyValues = this.newSelectValues.filter(val => val.length > 0);
			let data = {
				name: this.newName,
				help: this.newHelp,
				placeholder: this.newPlaceholder,
				type: this.newType,
				required: this.newRequired,
				internal: this.newInternal,
				show_in_list: this.newShowInList,
				show_in_details: this.newShowInDetails,
				select_values: JSON.stringify(nonEmptyValues),
			};
			this.$http.put('/private/customfield/' + this.customfield.id, data).then(() => {
				this.$store.dispatch('loadResources', {root: true});
				this.isLoading = false;
				this.close();
			}).catch(() => {
				this.isLoading = false;
				this.showError = true;
			});
		}
	}

}
